import { Button, Card, CardMedia, Divider, useTheme } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { NoRecordsFound } from 'framework/components/NoRecordsFound';
import { SearchbarWithParams } from 'framework/components/search/SearchbarWithParams';
import { useQueryContext } from 'framework/hooks/useQueryContext';
import { PageableTableWithColumnSelection } from 'framework/table/PageableTableWithColumnSelection';
import { onResetToPage1 } from 'framework/types/onResetToPage1';
import { deliveriesQuery_export, DeliveryExportProp, DeliveryExportProps, IDeliveriesFilterParams, IDelivery } from 'gen/ApiClient';
import { useLocalization } from 'localization/useLocalization';
import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { useDialogsContext } from 'shared/dialogs/useDialogsContext';
import { ExportButtonMenuAndDialog } from 'shared/export/ExportButtonMenuAndDialog';
import { IReloadTriggerProps } from 'shared/layout/IReloadTriggerProps';
import { RestrictedContent } from 'shared/layout/RestrictedContent';
import { SelectColumnsButtonAndDialog } from 'shared/selectColumns/SelectColumnsButtonAndDialog';
import { createDetailsNavigateHeader } from 'shared/table/createDetailsNavigateHeader';
import { calcDeliveryDetailRoute } from '../../../routes';
import { DeliveriesQueryContext } from './DeliveriesQueryContext';
import { DeliveriesListViewContext } from './DeliveriesListViewContext';
import { RegisterDeliveryRequestForm } from '../forms/RegisterDeliveryRequestForm';
import { DeliveriesFilter } from './DeliveriesFilter';
import { DeliveriesSelectableColumn } from './DeliveriesSelectableColumn';

export const DeliveriesListPage = ({ reloadTrigger }: IReloadTriggerProps) => {
	const strings = useLocalization();
	const theme = useTheme();
	const { params, setParams, queryResult, reload } = useQueryContext(DeliveriesQueryContext, reloadTrigger);
	const { columns, columnsRecord, setColumns, exportRecord, headers } = useContext(DeliveriesListViewContext);
	const { push } = useHistory();
	const { open, confirm, cancel } = useDialogsContext(reload);

	if (queryResult === undefined) {
		return <div></div>;
	}

	const onNew = () => {
		open(
			<RegisterDeliveryRequestForm
				open
				confirm={onConfirmNew}
				cancel={cancel}
			/>
		);
	};

	const onConfirmNew = (id: string) => {
		confirm();
		push(calcDeliveryDetailRoute(id));
	};

	return (
		<RestrictedContent pageClaim='Deliveries'>
			<div className='df-row-ac jc-sb'>
				<SearchbarWithParams
					params={params}
					setParams={setParams}
					placeholder={strings.searchVerb}
					style={{ width: '400px' }}
					variant='paper'
				/>
				<Button
					variant='contained'
					color='primary'
					startIcon={<AddIcon />}
					onClick={onNew}>
					{strings.newWhat(strings.delivery)}
				</Button>
			</div>
			{queryResult.unfilteredCount > 0 && (
				<>
					<Card>
						<div className='df-row jc-sb'>
							<DeliveriesFilter
								params={params}
								onFilter={params => setParams(onResetToPage1(params))}
								paddingLeft={theme.spacing(1.5)}
							/>
							<div
								className='df-row-ac'
								style={{ paddingRight: theme.spacing(1.5) }}>
								<ExportButtonMenuAndDialog<IDeliveriesFilterParams, DeliveryExportProp>
									params={params}
									filteredCount={queryResult.filteredCount}
									unfilteredCount={queryResult.unfilteredCount}
									allProps={DeliveryExportProps}
									downloadF={deliveriesQuery_export}
									fileName={strings.locations}
									record={exportRecord}
									view='deliveries'
								/>
								<SelectColumnsButtonAndDialog
									selectedColumns={columns}
									setSelectedColumns={setColumns}
									record={columnsRecord}
									view='deliveries'
								/>
							</div>
						</div>
						<Divider />
						<CardMedia>
							<PageableTableWithColumnSelection<IDelivery, DeliveriesSelectableColumn>
								queryResult={queryResult}
								headers={headers}
								sortParams={params.sortParams}
								pageParams={params.pageParams}
								setParams={(sp, pp) => setParams({ ...params, sortParams: sp, pageParams: pp })}
								getKey={inst => inst.id}
								selectedColumns={columns}
								appendColumn={createDetailsNavigateHeader<IDelivery>(calcDeliveryDetailRoute)}
							/>
						</CardMedia>
					</Card>
				</>
			)}
			{queryResult.unfilteredCount === 0 && <NoRecordsFound>{strings.noWhatRegistered(strings.deliveries)}</NoRecordsFound>}
		</RestrictedContent>
	);
};
